export default __webpack_public_path__ + "static/study-seminar1-f6fa097e12cf57b31be602029d916cf8.jpg";